var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColdMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Heat / Cold Mode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.425 16.05C4.675 15.5 4.08333 14.8125 3.65 13.9875C3.21667 13.1625 3 12.25 3 11.25C3 9.93333 3.3125 8.7625 3.9375 7.7375C4.5625 6.7125 5.25 5.85 6 5.15C6.75 4.45 7.4375 3.91667 8.0625 3.55L9 3V5.475C9 5.89167 9.15 6.24583 9.45 6.5375C9.75 6.82917 10.1083 6.975 10.525 6.975C10.7583 6.975 10.975 6.925 11.175 6.825C11.375 6.725 11.5417 6.58333 11.675 6.4L12 6C12.6333 6.35 13.175 6.79583 13.625 7.3375C14.075 7.87917 14.4167 8.48333 14.65 9.15L12.075 11.725L11.9625 11.6125L11.85 11.5L9 8.7L6.2 11.5C5.83333 11.8667 5.54167 12.2875 5.325 12.7625C5.10833 13.2375 5 13.7417 5 14.275C5 14.6083 5.0375 14.9208 5.1125 15.2125C5.1875 15.5042 5.29167 15.7833 5.425 16.05ZM7.875 15.925C7.60833 15.7417 7.39583 15.5042 7.2375 15.2125C7.07917 14.9208 7 14.6083 7 14.275C7 13.9917 7.05417 13.7417 7.1625 13.525C7.27083 13.3083 7.41667 13.1083 7.6 12.925L9 11.525L10.425 12.9C10.475 12.9333 10.5167 12.975 10.55 13.025C10.5833 13.075 10.6167 13.1167 10.65 13.15L7.875 15.925ZM7.4 22L6 20.6L19.6 7L21 8.4L17.4 12H21V14H15.4L14.9 14.5L16.4 16H21V18H18.4L20.5 20.1L19.1 21.5L17 19.4V22H15V17.4L13.5 15.9L13 16.4V22H11V18.4L7.4 22Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdMode);
export default __webpack_public_path__ + "static/media/cold-mode.7ed70b43523b2a369dceb8cd105cdf46.svg";
export { ForwardRef as ReactComponent };